import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/PoliticaDePrivacidade";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () =>
    pageHead({
      title: "Política de Privacidade | Clara Camille Nutricionista",
      description:
        "Política de privacidade do site da Clara Camille, nutricionista brasileira na Austrália. Saiba como seus dados são coletados e protegidos.",
      path: "/politica-de-privacidade",
    }),
  component: Page,
});
